import React, { useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { api, formatApiErrorDetail } from "@/lib/api";
import { Lock, Check } from "lucide-react";

export default function ResetPassword() {
    const { t } = useTranslation();
    const [params] = useSearchParams();
    const token = params.get("token") || "";
    const navigate = useNavigate();
    const [pw, setPw] = useState("");
    const [ok, setOk] = useState(false);
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        setError(""); setLoading(true);
        try {
            await api.post("/auth/reset-password", { token, new_password: pw });
            setOk(true);
            setTimeout(() => navigate("/login"), 1800);
        } catch (err) {
            setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
        } finally { setLoading(false); }
    };

    return (
        <div className="parchment min-h-[calc(100vh-4rem)] flex items-center justify-center px-6 py-16">
            <div className="w-full max-w-md p-card p-8 sm:p-10" data-testid="reset-card">
                <div className="flex items-center gap-2 mb-4">
                    <div className="h-10 w-10 rounded-full flex items-center justify-center" style={{ background: "#1E1B4B", color: "#D4AF37" }}>
                        <Lock size={18} />
                    </div>
                    <div className="font-display text-3xl" style={{ color: "#1E1B4B" }}>{t("forgot.reset_h")}</div>
                </div>
                <p className="text-sm mb-5" style={{ color: "#525252" }}>{t("forgot.reset_sub")}</p>
                {ok ? (
                    <div className="p-4 rounded-2xl text-sm inline-flex items-center gap-2"
                         style={{ background: "#F5F0E6", color: "#1E1B4B" }} data-testid="reset-ok">
                        <Check size={14} style={{ color: "#7F1D1D" }} /> {t("forgot.reset_ok")}
                    </div>
                ) : (
                    <form onSubmit={submit} className="space-y-4">
                        <div>
                            <label className="block text-xs uppercase tracking-[0.22em] mb-1.5" style={{ color: "#7F1D1D" }}>{t("forgot.new_password")}</label>
                            <input type="password" required minLength={6} value={pw} onChange={(e) => setPw(e.target.value)}
                                   className="w-full px-4 py-3 rounded-full border"
                                   style={{ borderColor: "#E5E0D8", background: "#FDFBF7" }}
                                   data-testid="reset-password-input" />
                        </div>
                        {error && <div className="text-sm" style={{ color: "#7F1D1D" }} data-testid="reset-error">{error}</div>}
                        <button type="submit" disabled={loading || !token} className="btn-primary w-full disabled:opacity-60" data-testid="reset-submit-button">
                            {loading ? "…" : t("forgot.reset_submit")}
                        </button>
                    </form>
                )}
                <div className="mt-6 text-sm text-center">
                    <Link to="/login" className="underline" style={{ color: "#1E1B4B" }} data-testid="reset-back-link">{t("forgot.back")}</Link>
                </div>
            </div>
        </div>
    );
}
